(function () {
  const AUTO_ADVANCE_DELAY = 5000; // 5 seconds of inactivity
  const SLIDE_TRANSITION = 800;    // slide animation duration in ms

  const initAutoAdvance = () => {
    const isHomePage =
      window.location.pathname === "/" ||
      document.body.classList.contains("template-index");

    if (!isHomePage) return;

    const swiperWrapper = document.querySelector(".swiper-wrapper.slider-demo-wrapper");
    if (!swiperWrapper) return;

    const waitForSwiper = setInterval(() => {
      const swiperEl = swiperWrapper.closest(".swiper") || swiperWrapper.parentElement;
      const swiperInstance = swiperEl?.swiper;

      if (!swiperInstance) return;
      clearInterval(waitForSwiper);

      let inactivityTimer = null;

      // Advance to next slide, loop back to 0 from last
      const goToNextSlide = () => {
        const totalSlides = swiperInstance.slides.length;
        const nextIndex = (swiperInstance.activeIndex + 1) % totalSlides;
        swiperInstance.slideTo(nextIndex, SLIDE_TRANSITION);
      };

      // Start/restart the inactivity countdown
      const resetTimer = () => {
        clearTimeout(inactivityTimer);
        inactivityTimer = setTimeout(goToNextSlide, AUTO_ADVANCE_DELAY);
      };

      // User activity events to watch
      const activityEvents = [
        "mousemove",
        "mousedown",
        "touchstart",
        "touchmove",
        "keydown",
        "wheel",
        "scroll",
        "click",
      ];

      activityEvents.forEach((event) => {
        window.addEventListener(event, resetTimer, { passive: true });
      });

      // Also reset timer on manual slide change (e.g. swipe or arrow keys)
      swiperInstance.on("slideChange", () => {
        resetTimer();
      });

      // Pause auto-advance when tab is hidden, resume when visible
      document.addEventListener("visibilitychange", () => {
        if (document.hidden) {
          clearTimeout(inactivityTimer);
        } else {
          resetTimer();
        }
      });

      // Kick off the first timer
      resetTimer();
    }, 200);
  };

  initAutoAdvance();

  document.addEventListener("shopify:section:load", () => {
    initAutoAdvance();
  });
})();